<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-offline">
            <div class="common-text mb-1">
                Нет соединения с номером
            </div>
            <div class="main-text">
                Обновите страницу позже
            </div>
            <v-btn class="main-text btn-gradient mt-5" @click="openProfile">
                Профиль
            </v-btn>
            <v-btn class="main-text btn-grey mt-3" @click="reloadPage">
                Обновить страницу
            </v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalOffline",
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        },
        openProfile() {
            this.$router.push({ name: "profile" });
        },
        reloadPage() {
            window.location.reload();
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-offline.v-card {
    padding: 24px;
    background: #FFFFFF;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
</style>